import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Image from '../Image/Image.inner';
import * as S from './Carousel.styles';
import {
  MAX_WIDTH,
  MAX_WIDTH_IMAGES,
  MIN_WIDTH_IMAGES,
} from '../../utils/Constants';

const carouselVariant = {
  home: 'home',
  dashboard: 'dashboard',
};

const Carousel = ({
  images,
  interval,
  transitionInterval,
  variant,
  fetchFunction = () => {},
}) => {
  const carousel = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (selectedIndex) => {
    setActiveIndex(selectedIndex);
    movement(selectedIndex);
  };

  const movement = useCallback(
    (selectedIndex) => {
      if (images.length > 0) {
        let mov;
        if (window.innerWidth <= MAX_WIDTH) {
          mov = -MAX_WIDTH_IMAGES * selectedIndex;
        } else {
          mov = -MIN_WIDTH_IMAGES * selectedIndex;
        }
        carousel.current.style.transform = `translateX(${mov}px)`;
        carousel.current.style.transition = `${transitionInterval}ms ease-out all`;
      }
    },
    [images.length, transitionInterval]
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (activeIndex === images.length - 1) {
        setActiveIndex(0);
        movement(0);
      } else {
        setActiveIndex(activeIndex + 1);
        movement(activeIndex + 1);
      }
    }, interval);
    return () => clearInterval(intervalId);
  }, [activeIndex, images.length, interval, movement]);

  const handleImageClick = (element, e) => {
    if (element.isFunction) {
      e.preventDefault();
      fetchFunction(element.fileId);
    }
  };
  return (
    <S.Carousel variant={carouselVariant[variant]}>
      <S.CarouselImagesWrapper ref={carousel}>
        {images.map((element, index) => (
          <S.CarouselImage
            key={`${element.imageURL}-${index}`}
            variant={carouselVariant[variant]}
          >
            <a
              href={`${element.href}`}
              target={element.isLocalRef ? '_self' : '_blank'}
              rel='noreferrer'
              onClick={(e) => handleImageClick(element, e)}
            >
              <Image
                name={element.imageURL}
                alt={element.altImage}
                cursor='onClick'
                isExternalSrc
              />
            </a>
          </S.CarouselImage>
        ))}
      </S.CarouselImagesWrapper>
      <S.CarouselBottom variant={carouselVariant[variant]}>
        {images.length > 1 &&
          images.map((element, index) => (
            <S.Oval
              key={`data-oval-${index}`}
              variant={activeIndex === index ? 'primary' : 'neutral'}
              onClick={() => {
                handleClick(index);
              }}
            />
          ))}
      </S.CarouselBottom>
    </S.Carousel>
  );
};
Carousel.defaultProps = {
  interval: 5000,
  transitionInterval: 1000,
  variant: 'dashboard',
};
Carousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      imageURL: PropTypes.string.isRequired,
      isLocalRef: PropTypes.bool.isRequired,
      isFunction: PropTypes.bool,
      fileId: PropTypes.string,
      altImage: PropTypes.string.isRequired,
    })
  ).isRequired,
  interval: PropTypes.number,
  transitionInterval: PropTypes.number,
  variant: PropTypes.oneOf(['home', 'dashboard']),
};
export default Carousel;
